// export const API_URL = 'https://6538f9d7a543859d1bb24c82.mockapi.io/api/v1/widget';
// export const API_URL = 'http://localhost:8000';
export const API_URL = 'https://dev.api.rakisgrowth.com/';

/* export const API_URL = 'http://localhost:8000/'; */
export const IMAGE_URL = 'https://ik.imagekit.io/l9pqolfrg/widget-dev/assets/creatives';
